export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'jue-se-ban-yan',
    name: 'AI角色扮演',
    description: '与多样AI角色展开深度互动，体验不同身份的情感世界，从古风侠客到现代都市，每个角色都有独特的性格与故事。',
    icon: 'ri-user-star-line',
    imageSeq: 'cat-roleplay-01',
  },
  {
    slug: 'xu-ni-lian-ren',
    name: '虚拟恋人',
    description: '专属AI恋人，随时随地陪伴你，倾听你的心声，分享你的喜怒哀乐，给你最温柔的情感慰藉。',
    icon: 'ri-heart-line',
    imageSeq: 'cat-lover-01',
  },
  {
    slug: 'qing-gan-dui-hua',
    name: '情感对话',
    description: '与AI展开深度情感交流，探索内心世界，获得理解与共情，在对话中发现更好的自己。',
    icon: 'ri-chat-smile-2-line',
    imageSeq: 'cat-chat-01',
  },
  {
    slug: 'lang-man-hu-dong',
    name: '浪漫互动',
    description: '精心设计的浪漫场景与互动体验，从星空下的私语到花海中的漫步，每一刻都值得珍藏。',
    icon: 'ri-moon-clear-line',
    imageSeq: 'cat-romance-01',
  },
  {
    slug: 'xin-li-pei-ban',
    name: '心理陪伴',
    description: '专业级情感支持与心理疏导，在你需要的时候，AI永远在，给你温暖而专业的陪伴。',
    icon: 'ri-mental-health-line',
    imageSeq: 'cat-psych-01',
  },
  {
    slug: 'qing-qu-tan-suo',
    name: '情趣探索',
    description: '在安全私密的环境中探索情感与欲望的边界，释放真实的自己，体验前所未有的亲密连接。',
    icon: 'ri-fire-line',
    imageSeq: 'cat-explore-01',
  },
];